import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import "../styles/Payment.css";

const Payment = () => {
  const { token } = useParams();

  const [isPending, setIsPending] = useState(true);

  return (
    <section className="section-payment">
      <div className="payment">
        <iframe
          src={`https://accept.paymob.com/api/acceptance/iframes/377914?payment_token=${token}`}
          title="payment"
          style={{
            height: "100%",
            width: "100%",
          }}
          id="payment"
          frameBorder="0"
          // scrolling="no"
        />
      </div>
    </section>
  );
};

export default Payment;
